module.exports = __webpack_public_path__ + "img/coin-selected-white.ff743d04.png";